import React from "react";
import { CONTACT_PHONE, CONTACT_PHONE_RAW, CONTACT_EMAIL, CONTACT_ADDRESS } from "@/lib/brand";

// Build a vCard (v3.0) file for FarmStory. Guests tap → the phone
// prompts them to add "FarmStory" to their contacts.
function buildVCardBlob() {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "FN:FarmStory",
    "ORG:FarmStory",
    "TITLE:An Agri-Ecological Retreat · Sundarbans",
    `TEL;TYPE=CELL,VOICE:+${CONTACT_PHONE_RAW}`,
    `TEL;TYPE=WhatsApp:+${CONTACT_PHONE_RAW}`,
    `EMAIL;TYPE=INTERNET:${CONTACT_EMAIL}`,
    `ADR;TYPE=WORK:;;${CONTACT_ADDRESS};;;;`,
    "URL:https://farmstoryindia.com",
    "NOTE:Rooted in wonder.",
    "END:VCARD",
    "",
  ].join("\r\n");
  return new Blob([lines], { type: "text/vcard;charset=utf-8" });
}

/**
 * A small, quiet text link that reads "Save the number" and downloads
 * a .vcf file of FarmStory's contact card.
 *
 * Placed next to Message-on-WhatsApp CTAs.
 */
export default function SaveNumberLink({
  className = "",
  tone = "light", // "light" for dark backgrounds, "dark" for cream/salt backgrounds
  testId = "save-number-link",
  label = "Save the number",
}) {
  const [saved, setSaved] = React.useState(false);

  const onClick = (e) => {
    e.preventDefault();
    try {
      const blob = buildVCardBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "FarmStory.vcf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // Revoke a little later so mobile Safari has time to open it.
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      // Fallback: navigate to a tel: link so the number is at least dialable.
      window.location.href = `tel:+${CONTACT_PHONE_RAW}`;
    }
  };

  const color =
    tone === "light" ? "rgba(242,233,212,0.72)" : "rgba(26,42,30,0.68)";
  const hover =
    tone === "light" ? "var(--sundari-gold)" : "var(--mangrove-night)";

  return (
    <a
      href="#save-number"
      onClick={onClick}
      data-testid={testId}
      className={`label-track link-fade ${className}`}
      style={{
        color,
        fontSize: "11px",
        letterSpacing: "0.18em",
        borderBottom: "1px solid currentColor",
        paddingBottom: 2,
      }}
      onMouseEnter={(e) => (e.currentTarget.style.color = hover)}
      onMouseLeave={(e) => (e.currentTarget.style.color = color)}
      aria-label={`Save FarmStory as a contact (${CONTACT_PHONE})`}
    >
      {saved ? "Saved · Check your contacts" : label}
    </a>
  );
}
